import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { GDMELogo, TalkinPointLogo } from './PlatformLogos';

const NewChatModal = ({ show, onClose, searchQuery, onSearch, searchUsers, onStartChat }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.95 }}
          onClick={e => e.stopPropagation()}
          className="bg-white rounded-2xl w-full max-w-md p-6"
        >
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-gray-900">New Message</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FaTimes />
            </button>
          </div>

          {/* Platform selector */}
          <div className="flex space-x-2 mb-4">
            <div className="flex items-center space-x-2 px-3 py-2 bg-blue-50 rounded-lg border border-blue-200">
              <TalkinPointLogo size="sm" />
              <span className="text-sm text-blue-700">TalkinPoint</span>
            </div>
            <div className="flex items-center space-x-2 px-3 py-2 bg-purple-50 rounded-lg border border-purple-200">
              <GDMELogo size="sm" />
              <span className="text-sm text-purple-700">GDME</span>
            </div>
          </div>

          <div className="relative mb-4">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search users on both platforms..."
              value={searchQuery}
              onChange={(e) => onSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-gray-100 border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
              autoFocus
            />
          </div>
          <div className="max-h-64 overflow-y-auto">
            {searchUsers.length > 0 ? (
              searchUsers.map(user => (
                <div
                  key={user.id}
                  onClick={() => onStartChat(user)}
                  className="flex items-center space-x-3 p-3 hover:bg-gray-50 rounded-lg cursor-pointer"
                >
                  <div className="relative">
                    <img
                      src={user.avatar_url || 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg'}
                      alt={user.full_name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div className="absolute -bottom-1 -right-1">
                      {user.platform === 'gdme' ? <GDMELogo size="sm" /> : <TalkinPointLogo size="sm" />}
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-900 font-medium">{user.full_name}</p>
                    <p className="text-gray-500 text-sm">@{user.username}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    user.platform === 'gdme'
                      ? 'bg-purple-100 text-purple-600'
                      : 'bg-blue-100 text-blue-600'
                  }`}>
                    {user.platform === 'gdme' ? 'GDME' : 'TP'}
                  </span>
                </div>
              ))
            ) : searchQuery.length >= 2 ? (
              <p className="text-center text-gray-500 py-4">No users found</p>
            ) : (
              <p className="text-center text-gray-500 py-4">Search users on TalkinPoint & GDME</p>
            )}
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default NewChatModal;
